export class Company {
	id: number;
  number: number;
  description: string;
}
